import React from 'react';
import { Link } from 'react-router-dom';
import { MAIN_NAVIGATION, OPENING_HOURS, ADDRESS, CONTACT_INFO } from '../../data/constants';
import './Footer.css';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer>
      <div className="footer-wrapper">
        <div className="footer-menu">
          <h3>Fizjoterapia i Rehabilitacja Recz</h3>
	          <ul>
		            {MAIN_NAVIGATION.map((item, index) => (
		              <li key={index}>
		                <Link to={item.href} onClick={scrollToTop}>{item.text}</Link>
		              </li>
		            ))}
		            <li>
		              <a href="/regulamin.pdf" target="_blank" rel="noopener noreferrer">
		                Regulamin
		              </a>
		            </li>
		            <li><Link to="/prawa-pacjenta" onClick={scrollToTop}>Prawa pacjenta</Link></li>
		            <li><Link to="/informacje-rodo" onClick={scrollToTop}>Przepisy RODO</Link></li>
		          </ul>
		        </div>
        
        <div className="time-schedule">
          <h3>Godziny otwarcia</h3>
          {OPENING_HOURS.map((schedule, index) => (
            <React.Fragment key={index}>
              <p>{schedule.day}</p>
              <p>{schedule.hours}</p>
            </React.Fragment>
          ))}
        </div>
        
        <div className="address">
          <h3>Adres naszego Gabinetu Fizjoterapii i Rehabilitacji</h3>
          <p>{ADDRESS.postalCode} {ADDRESS.city}</p>
          <p>{ADDRESS.street}</p>
        </div>
        
        <div className="contact">
          <h3>Kontakt</h3>
          <p>Kontakt telefoniczny:</p>
          {CONTACT_INFO.map((contact, index) => (
            <a key={index} href={`tel:${contact.phone.replace(/\s/g, '')}`}>
              {contact.phone.replace(/\s/g, '')} - {contact.name}
            </a>
          ))}
        </div>
      </div>
      
      <div className="second-footer-wrapper">
        <div className="copyright-wrapper">
          <div className="copyright"></div>
          <div className="copyright-link">
            <a href="https://fizjoterapia-pabich.pl">
              Fizjoterapia i Rehabilitacja Recz FizjoFit P.G. Pabich
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
